import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setPickupMonitorCancelReason, setPickupMonitorShowCancelOrder, setPickupMonitorShowOrderModal } from '../../../../redux/action/pickupMonitor'
import { setAppEventZIndex } from '../../../../redux/action/system'
import { setOrderStatusThunk } from '../../../../redux/thunk/order/setOrderStatus'
import ButtonsModal from '../../../Elements/modal/ButtonsModal'

const EVENT_Z_INDEX = 2

const CancelOrder = React.memo(() => {
	const cancelReasonOptions = useSelector(store => store.pickupMonitor.cancelReasonOptions)
	const selectedOrder = useSelector(store => store.pickupMonitor.selectedOrder)
	const showCancelOrder = useSelector(store => store.pickupMonitor.modal.showCancelOrder)
	const cancelReasonFoodoraOptions = useSelector(store => store.pickupMonitor.cancelReasonFoodoraOptions)
	const isFoodoraPlugin = selectedOrder?.platformMetaData?.platformType === 'FOODORA_PLUGIN'
	const cancelReasons = isFoodoraPlugin ? cancelReasonFoodoraOptions : cancelReasonOptions
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const handleBack = useCallback(() => {
		dispatch(setPickupMonitorShowCancelOrder(false))
		dispatch(setPickupMonitorShowOrderModal(true))
		dispatch(setAppEventZIndex(1))
		dispatch(setPickupMonitorCancelReason(null))
	}, [dispatch])

	const handleChangeReason = useCallback(async (event, reason) => {
		if (event) event.preventDefault()
		if (isFoodoraPlugin) {
			const reasonCode = reason
			await dispatch(setOrderStatusThunk(selectedOrder, 'CANCELED', reason, reasonCode))
		} else {
			await dispatch(setOrderStatusThunk(selectedOrder, 'CANCELED', reason))
		}
		dispatch(setPickupMonitorShowCancelOrder(false))
		dispatch(setPickupMonitorShowOrderModal(false))
		dispatch(setPickupMonitorCancelReason(null))
		dispatch(setAppEventZIndex(0))
	}, [selectedOrder, isFoodoraPlugin, dispatch])

	const buttons = useMemo(() => cancelReasons?.map((option, i) =>
		({ icon: 'cancel', text: t(option.label), onClick: e => handleChangeReason(e, option.value), show: true })), [cancelReasons, handleChangeReason, t])

	return (
		<ButtonsModal isOpen={showCancelOrder}
									close={handleBack}
									title={t('order.modal.want_cancel_order')}
									size="small"
									zIndex={EVENT_Z_INDEX}
									buttons={buttons} />
	)
})

CancelOrder.displayName = 'CancelOrder'
export default CancelOrder
